import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { useOnlineStatus } from '@/hooks/useOnlineStatus';

/** API failures remain in each screen; online never implies service availability. */
export default function MvpConnection({ children }: { children: ReactNode }) {
  const online = useOnlineStatus();
  const { t } = useTranslation('system');
  return (
    <>
      {!online && (
        <div
          role="alert"
          className="border-b border-gp-pink-700 bg-gp-pink-100 px-4 py-3"
        >
          <p className="text-body font-semibold">{t('offline.title')}</p>
          <p className="text-caption text-gp-ink-600">{t('offline.body')}</p>
        </div>
      )}
      {children}
    </>
  );
}
